import { c as _c } from "react/compiler-runtime";
import { Button, Heading, HStack, Image, Link, SimpleGrid, Spacer, Spinner, Text, VStack } from '@chakra-ui/react';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import { HS_CHAT_OPEN_HASH, openHubspotChat } from '@src/components/sco/utilities/HubspotChatHandler';
import { HubspotChatLoadStatus, useHubspotChatLoadStatus } from '@src/components/sco/utilities/HubspotChatHandler/useHubspotChatLoadStatus';
const HubspotChatStatus = t0 => {
  const $ = _c(8);
  const {
    status
  } = t0;
  const label = status === "ready" ? "Live chat ready." : status === "unavailable." ? "Live chat unavailable" : "Connecting to live chat\u2026";
  const t1 = status === "ready" ? "fg.success" : status === "unavailable" ? "fg.error" : "fg.muted";
  let t2;
  if ($[0] !== status) {
    t2 = status === "loading" && <Spinner size="xs" />;
    $[0] = status;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== label) {
    t3 = <Text color="inherit" fontSize="xs" textAlign="center">{label}</Text>;
    $[2] = label;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t1 || $[5] !== t2 || $[6] !== t3) {
    t4 = <HStack color={t1} gap={2} justify="center">{t2}{t3}</HStack>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};
export const SupportOptionsBlock = () => {
  const $ = _c(26);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  const chatStatus = useHubspotChatLoadStatus();
  const chatUnavailable = chatStatus === "unavailable";
  let t0;
  if ($[0] !== getBreakpointValue) {
    t0 = getBreakpointValue([1, 1, 3]);
    $[0] = getBreakpointValue;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Image maxWidth={["32px", "32px", "72px"]} src="/assets/illustration/support/emailus.svg" />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Heading>Email</Heading>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Text color="textPrimary" fontSize="md" textAlign="center">{"Send us an email at:"}{" "}<Link color="yellow.600" href="mailto:support@startups.com" variant="underline">support@startups.com</Link></Text>;
    t4 = <Spacer />;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <VStack bgColor="colorPalette.subtle/50" border="1px solid" borderColor="colorPalette.border/50" borderRadius="xl" boxShadow="lg" gap={5} padding={10} width="full">{t1}<VStack align="center" gap={3} justify="center">{t2}{t3}{t4}<Button asChild={true} size="md"><Link href="mailto:support@startups.com">Send an Email</Link></Button></VStack></VStack>;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Image maxWidth={["32px", "32px", "72px"]} src="/assets/illustration/support/livechat.svg" />;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  let t8;
  let t9;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Heading>Live Chat</Heading>;
    t8 = <Text color="textPrimary" fontSize="md" textAlign="center">Get real-time assistance with live on-site chat support.</Text>;
    t9 = <Spacer />;
    $[8] = t7;
    $[9] = t8;
    $[10] = t9;
  } else {
    t7 = $[8];
    t8 = $[9];
    t9 = $[10];
  }
  let t10;
  if ($[11] !== chatUnavailable) {
    t10 = chatUnavailable ? <Button disabled={true} size="md">Start Chat</Button> : <Button asChild={true} size="md"><Link href={HS_CHAT_OPEN_HASH} onClick={_temp}>Start Chat</Link></Button>;
    $[11] = chatUnavailable;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== chatStatus) {
    t11 = <HubspotChatStatus status={chatStatus} />;
    $[13] = chatStatus;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== t10 || $[16] !== t11) {
    t12 = <VStack bgColor="colorPalette.subtle/50" border="1px solid" borderColor="colorPalette.border/50" borderRadius="xl" boxShadow="lg" gap={5} padding={10} width="full">{t6}<VStack align="center" gap={3} justify="center">{t7}{t8}{t9}{t10}{t11}</VStack></VStack>;
    $[15] = t10;
    $[16] = t11;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <Image maxWidth={["32px", "32px", "72px"]} src="/assets/illustration/support/ticket.svg" />;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  let t15;
  let t16;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Heading>Support Ticket</Heading>;
    t15 = <Text color="textPrimary" fontSize="md" textAlign="center">Submit a ticket to our support team and they'll follow up.</Text>;
    t16 = <Spacer />;
    $[19] = t14;
    $[20] = t15;
    $[21] = t16;
  } else {
    t14 = $[19];
    t15 = $[20];
    t16 = $[21];
  }
  let t17;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <VStack bgColor="colorPalette.subtle/50" border="1px solid" borderColor="colorPalette.border/50" borderRadius="xl" boxShadow="lg" gap={5} padding={10} width="full">{t13}<VStack align="center" gap={3} justify="center">{t14}{t15}{t16}<Button asChild={true} size="md"><Link href="https://help.startups.com/knowledge/kb-tickets/new" target="_blank">Submit a Ticket</Link></Button></VStack></VStack>;
    $[22] = t17;
  } else {
    t17 = $[22];
  }
  let t18;
  if ($[23] !== t0 || $[24] !== t12) {
    t18 = <SimpleGrid columns={t0} gap={5} width="full">{t5}{t12}{t17}</SimpleGrid>;
    $[23] = t0;
    $[24] = t12;
    $[25] = t18;
  } else {
    t18 = $[25];
  }
  return t18;
};
function _temp(event) {
  event.preventDefault();
  openHubspotChat();
}